// extracted by mini-css-extract-plugin
export default {"AddAssesseeWrapper":"AddAssessee_AddAssesseeWrapper__nRhw2","Title":"AddAssessee_Title__GtHv6","Row":"AddAssessee_Row__qB6hs"};